import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {User} from '../domain/users/user.model';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {UserPasswordUpdate} from '../domain/users/user-password-update.model';

@Injectable()
export class UsersSharedService {

  constructor(private http: HttpClient) {
  }

  public me(): Observable<User> {
    return this.http.get<User>(`${environment.serviceUrl}/ums/users/me`);
  }

  public login(user: User): Observable<HttpResponse<string>> {
    return this.http.post(`${environment.serviceUrl}/ums/login`, user, {
        observe: 'response',
        responseType: 'text'
      }
    );
  }

  update(user: User): Observable<User> {
    return this.http.put<User>(`${environment.serviceUrl}/ums/users/${user.id}`, user);
  }

  changePassword(passwordUpdate: UserPasswordUpdate) {
    return this.http.put(`${environment.serviceUrl}/ums/users/change-password`, passwordUpdate);
  }
}
